export const PARAM_LABEL = {
  temp: 'Temp',
  salinity: 'Salinity',
  ammonia: 'Ammonia',
  nitrite: 'Nitrite',
  alkalinity: 'Alkalinity',
  depth: 'Depth',
  transparency: 'Transparency',
  // Tiles that must fit three to a row; matches the entry grid's short name.
  transparencyShort: 'Transp',
  calmag: 'Cal/Mag',
} as const;
